import { jsx as _jsx } from "react/jsx-runtime";
import style from "./style.module.scss";
export default function Divider() {
    return _jsx("div", { className: style["divider"] });
}
